import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/main/index.vue'
import Simple from '../views/main/simple.vue'
import Userprotocol from '../views/main/userprotocol.vue'
import Private from '../views/main/private.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/simple',
    name: 'Simple',
    component: Simple
  },
  {
    path: '/userprotocol',
    name: 'Userprotocol',
    component: Userprotocol
  },
  {
    path: '/private',
    name: 'Private',
    component: Private
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
